import { useStore } from 'effector-react'

import {
  $promoCodeList,
  $totalCountOfPromoCodeList,
  getPromoCodeList,
  promoCodeListMounted,
} from './model'
import { PromoCodeRequest } from './types'

export const usePromoCodeList = () => {
  const promoCodeList = useStore($promoCodeList)

  const loading = useStore(getPromoCodeList.pending)

  const totalCountOfPromoCodeList = useStore($totalCountOfPromoCodeList)

  const onChangePromoCodeList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    filters,
    searchText,
  }: PromoCodeRequest) => {
    promoCodeListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    promoCodeList,
    totalCountOfPromoCodeList,
    loading,
    onChangePromoCodeList,
  }
}
